import * as Sentry from '@sentry/react'

export function initSentry(app: string) {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_COMMIT_SHA,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    initialScope: { tags: { app } },
    // Lazy-chunk load failures. initPreloadErrorHandler reloads once to recover
    // a tab left on a superseded deploy; what survives that is a client that
    // cannot fetch our assets at all (blockers, scanners, dead networks) and is
    // not actionable, so it stays out of the issue stream.
    ignoreErrors: [
      /Unable to preload CSS/i,
      /Failed to fetch dynamically imported module/i,
      /error loading dynamically imported module/i,
      /Importing a module script failed/i,
    ],
  })
}
